import { IPolicyBuilderConfig } from "../types/builder";
import { PolicyFormNode } from "../types/policyForm";
import { buildPolicyBuilderIndexes } from "./policyBuilderIndexes";
import { mapBuilderConfigToFormNodes } from "./policyBuilderNode.mapper";

export class PolicyBuilderMapper {
  static mapToFormNodes(
    config: IPolicyBuilderConfig | null | undefined,
  ): PolicyFormNode[] | null {
    try {
      if (!config) {
        return null;
      }

      const indexes = buildPolicyBuilderIndexes(config);
      return mapBuilderConfigToFormNodes(indexes);
    } catch (error) {
      console.error("[PolicyBuilderMapper.mapToFormNodes]", { error });
      return null;
    }
  }
}
